import {
  call, put, select, takeLatest,
} from 'redux-saga/effects';
import api from '@/api/lesson';
import {
  LESSON_GET_LESSONS_REQUEST,
  LESSON_GET_LESSONS_SUCCESS,
  LESSON_GET_LESSON_RATE_REQUEST,
  LESSON_GET_LESSON_RATE_SUCCESS,
  LESSON_SET_CURRENT_REQUEST,
  LESSON_SET_CURRENT_SUCCESS,
  LESSON_SET_LESSON_RATE_REQUEST,
  LESSON_SET_LESSON_RATE_SUCCESS,
} from '@/action-types/lesson';
import {
  ERROR_PASS_REQUEST,
  ERROR_UPDATE_REQUEST,
} from '@/action-types/error';
import {
  LOADING_UPDATE_REQUEST,
} from '@/action-types/loading';
import { Action } from 'redux';

export function* getLessons(params: { courseId: number; }) {
  try {
    yield put({ type: LOADING_UPDATE_REQUEST, name: 'lesson', state: true });

    const data = yield call(api.getLessons, params.courseId);

    yield put({
      type: LESSON_GET_LESSONS_SUCCESS,
      lessons: data?.getLessons,
      courseId: params.courseId,
    });
  } catch (e) {
    yield put({ type: ERROR_PASS_REQUEST, error: e, tags: ['logic', 'getLessons'] });
    yield put({ type: ERROR_UPDATE_REQUEST, isActive: true, errorData: e });
  } finally {
    yield put({ type: LOADING_UPDATE_REQUEST, name: 'lesson', state: false });
  }
}

export function* setCurrent(params: { id: number; }) {
  yield put({ type: LESSON_SET_CURRENT_SUCCESS, current: params.id });
}

export function* getLessonRate() {
  try {
    const state = yield select();

    yield put({ type: LOADING_UPDATE_REQUEST, name: 'lesson_rates', state: true });

    const rateResponse = yield call(api.getLessonRate, parseInt(state.book.lesson.currentId, 10));

    // eslint-disable-next-line no-underscore-dangle
    delete rateResponse?.data?.getLessonRate?.rate?.__typename;

    yield put({
      type: LESSON_GET_LESSON_RATE_SUCCESS,
      lesson_rates: rateResponse.data?.getLessonRate?.rate || null,
    });
  } catch (e: any) {
    yield put({ type: ERROR_PASS_REQUEST, error: e, tags: ['logic', 'getLessonRate'] });
    throw Error(e.message);
  } finally {
    yield put({ type: LOADING_UPDATE_REQUEST, name: 'lesson_rates', state: false });
  }
}

export function* setLessonRate(params: { rates: {[k: string]: number;}; comment?: string;}) {
  try {
    yield put({ type: LOADING_UPDATE_REQUEST, name: 'lesson_rates', state: true });
    const state = yield select();
    yield call(
      api.setLessonRate,
      parseInt(state.book.lesson.currentId, 10),
      params.rates.platform_stability,
      params.rates.teaching_materials,
      params.rates.rate_teacher,
      params.comment,
    );

    yield put({ type: LESSON_SET_LESSON_RATE_SUCCESS, lesson_rates: params.rates });
  } catch (e: any) {
    yield put({ type: ERROR_PASS_REQUEST, error: e, tags: ['logic', 'setLessonRate'] });
    throw Error(e.message);
  } finally {
    yield put({ type: LOADING_UPDATE_REQUEST, name: 'lesson_rates', state: false });
  }
}

export default function* lesson() {
  // @ts-ignore
  yield takeLatest(LESSON_GET_LESSONS_REQUEST, getLessons);
  // @ts-ignore
  yield takeLatest(LESSON_SET_CURRENT_REQUEST, setCurrent);
  yield takeLatest(LESSON_GET_LESSON_RATE_REQUEST, getLessonRate);
  yield takeLatest<Action & {
    rates: {[k: string]: number;};
    comment?: string;
  }>(LESSON_SET_LESSON_RATE_REQUEST, setLessonRate);
}
